import React, {useState} from 'react';
import {useSelector} from "react-redux";
import ContainerDimensions from 'react-container-dimensions';

import {makeStyles, useMediaQuery, useTheme, withWidth} from '@material-ui/core';

import MainToolbar from './MainToolbar';
import MapGoogle from './mapGoogle/MapGoogle'
import CurrentLocationMapGoogle from './mapGoogle/CurrentLocationMapGoogle';
import GeofenceMapGoogle from './mapGoogle/GeofenceMapGoogle';
import AccuracyMapGoogle from './mapGoogle/AccuracyMapGoogle';
import CurrentPositionsMapGoogle from './mapGoogle/CurrentPositionsMapGoogle';
import SelectedDeviceMapGoogle from './mapGoogle/SelectedDeviceMapGoogle';
import Map from './map/Map';
import SelectedDeviceMap from './map/SelectedDeviceMap';
import AccuracyMap from './map/AccuracyMap';
import GeofenceMap from './map/GeofenceMap';
import CurrentPositionsMap from './map/CurrentPositionsMap';
import CurrentLocationMap from './map/CurrentLocationMap';
import DevicesDrawer from "./DevicesDrawer";
import {cyberStyles} from "./cssShared/cyberTheme";

const useStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  mapContainer: {
    flexGrow: 1,
  },
}));

const MainPage = ({ width }) => {
  const classes = useStyles();
  const [googleMapInstance, setGoogleMapInstance] = useState(null);

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  const user = useSelector(state => state.session.user);
  const mapType = user.map;


  return (
      <div className={classes.root}>
        {isDesktop && <MainToolbar />}

        <div className={classes.contentMainPage}>
          <DevicesDrawer width={width} googleMap={googleMapInstance} />

          <div className={classes.mapContainer}>
            <ContainerDimensions>
              {mapType === 'googleMap' ?
                  <MapGoogle onMapReady={setGoogleMapInstance}>
                    <CurrentLocationMapGoogle />
                    <GeofenceMapGoogle />
                    <AccuracyMapGoogle />
                    <CurrentPositionsMapGoogle />
                    <SelectedDeviceMapGoogle />
                  </MapGoogle>
                  :
                  <Map>
                    <CurrentLocationMap/>
                    <GeofenceMap/>
                    <AccuracyMap/>
                    <CurrentPositionsMap/>
                    <SelectedDeviceMap/>
                  </Map>
              }
            </ContainerDimensions>
          </div>
        </div>
      </div>
  );
}

export default withWidth()(MainPage);
